export const SESSION_STORAGE_IS_FIRST_LOGIN = 'isFirstLogin'
export const SESSION_STORAGE_SEEN_ADD_HOME_SCREEN_BANNER = 'seenAddHomeScreenBanner'
export const SESSION_STORAGE_RELOAD_PAGE_COUNT = 'reloadPageCount'
export const SESSION_STORAGE_ANON_TRANSACTION = 'isCloseAnonTransaction'
